const utilizationProvider = {
  titleAndSubtitle: {
    title: 'Provider Utilization',
    subtitle:
      'A listing of the top facilities and physicians utilized by plan members.',
    for: 'for',
  },
  CalendarCard: {
    from: 'Jan 2021',
    to: 'Dec 2022',
  },
  cardText: {
    members: 'Members',
    totalCost: 'Total Cost',
    medical: 'Medical',
    rx: 'Rx',
    pmpm: 'PMPM',
    pepm: 'PEPM',
  },
  TableTextForTopFacilities: {
    title: 'Top Facilities',
    subtitle: 'These are the top facilities based on your network selection',
    leftToggleText: 'In-Network',
    rightToggleText: 'Out-of-Network',
  },
  TableTextForTopPhysicans: {
    title: 'Top Physicians',
    subtitle: 'These are the top physicians based on your network selection',
    leftToggleText: 'In Network',
    rightToggleText: 'Out Network',
  },
};
export default utilizationProvider;